module.exports = __webpack_public_path__ + "img/camm.1c3433b0.jpg";